import 'svelte/internal/disclose-version';

AdminRefresh[$.FILENAME] = 'src/pages/AdminRefresh.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import AdminNav from "../components/AdminNav.svelte";
import EmptyState from "../components/EmptyState.svelte";
import { session } from "../lib/session.svelte.js";
import { toastError, toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<div class="panel svelte-1j3ylwg"><p class="warn svelte-1j3ylwg"> </p> <p class="muted svelte-1j3ylwg">Set <code class="svelte-1j3ylwg">GOOGLE_PLACES_API_KEY</code> and restart the server to enable refreshing.</p></div>`), AdminRefresh[$.FILENAME], [[121, 4, [[122, 6], [123, 6, [[124, 12]]]]]]);
var root_1 = $.add_locations($.from_html(`<p class="muted svelte-1j3ylwg">Checking how much data is stale…</p>`), AdminRefresh[$.FILENAME], [[128, 4]]);
var root_2 = $.add_locations($.from_html(`<div class="panel svelte-1j3ylwg"><div class="progress svelte-1j3ylwg" role="progressbar" aria-valuemin="0" aria-valuemax="100"><div class="bar svelte-1j3ylwg"></div></div> <p class="status svelte-1j3ylwg"> <span class="muted svelte-1j3ylwg"> </span></p></div>`), AdminRefresh[$.FILENAME], [[130, 4, [[131, 6, [[132, 8]]], [134, 6, [[136, 8]]]]]]);
var root_3 = $.add_locations($.from_html(`<p class="status svelte-1j3ylwg"> </p>`), AdminRefresh[$.FILENAME], [[145, 8]]);
var root_4 = $.add_locations($.from_html(`<strong> </strong> `, 1), AdminRefresh[$.FILENAME], [[155, 12]]);

var root_5 = $.add_locations(
	$.from_html(`<label class="force svelte-1j3ylwg"><input type="checkbox" class="svelte-1j3ylwg"/> <span> <em class="svelte-1j3ylwg">For a backfill. Freshness says nothing about whether a listing holds a field that
                was added after it was last fetched.</em></span></label>`),
	AdminRefresh[$.FILENAME],
	[[171, 10, [[172, 12], [173, 12, [[175, 14]]]]]]
);

var root_6 = $.add_locations($.from_html(`<button class="primary svelte-1j3ylwg"> </button>`), AdminRefresh[$.FILENAME], [[184, 10]]);
var root_7 = $.add_locations($.from_html(`<p class="status svelte-1j3ylwg"><!> <span class="muted svelte-1j3ylwg"><!> <!></span></p> <!> <!>`, 1), AdminRefresh[$.FILENAME], [[151, 8, [[158, 10]]]]);
var root_8 = $.add_locations($.from_html(`<div class="panel svelte-1j3ylwg"><!></div>`), AdminRefresh[$.FILENAME], [[143, 4]]);
var root_9 = $.add_locations($.from_html(`<!> <header class="intro svelte-1j3ylwg"><h1 class="svelte-1j3ylwg">Refresh provider data</h1> <p class="svelte-1j3ylwg"> </p></header> <!>`, 1), AdminRefresh[$.FILENAME], [[110, 2, [[111, 4], [112, 4]]]]);

const $$css = {
	hash: 'svelte-1j3ylwg',
	code: '\n  .intro.svelte-1j3ylwg { padding: 8px 0 22px; }\n  .intro.svelte-1j3ylwg h1:where(.svelte-1j3ylwg) { font-size: 1.5rem; }\n  .intro.svelte-1j3ylwg p:where(.svelte-1j3ylwg) { margin: 8px 0 0; max-width: 62ch; color: var(--ink-soft); font-size: 0.92rem; line-height: 1.6; }\n\n  .panel.svelte-1j3ylwg {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n    padding: 0.9rem 1rem;\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius);\n    background: var(--card);\n  }\n  .panel.svelte-1j3ylwg .status:where(.svelte-1j3ylwg) { margin: 0; flex: 1 1 20rem; font-size: 0.9rem; line-height: 1.55; }\n  .panel.svelte-1j3ylwg .status:where(.svelte-1j3ylwg) .muted:where(.svelte-1j3ylwg) { display: block; font-size: 0.82rem; }\n  .warn.svelte-1j3ylwg { margin: 0; flex: 1 1 20rem; color: var(--accent-dark); font-size: 0.9rem; }\n  .force.svelte-1j3ylwg {\n    display: flex;\n    align-items: flex-start;\n    gap: 9px;\n    flex: 1 1 100%;\n    padding: 10px 12px;\n    border: 1px solid var(--line);\n    border-radius: var(--radius-sm);\n    background: var(--card-soft);\n    font-size: 0.86rem;\n    cursor: pointer;\n  }\n  .force.svelte-1j3ylwg input:where(.svelte-1j3ylwg) { accent-color: var(--accent); margin: 2px 0 0; cursor: pointer; flex: none; }\n  .force.svelte-1j3ylwg em:where(.svelte-1j3ylwg) {\n    display: block;\n    margin-top: 2px;\n    color: var(--ink-faint);\n    font-size: 0.78rem;\n    font-style: normal;\n  }\n  .muted.svelte-1j3ylwg { color: var(--ink-faint); font-size: 0.84rem; }\n  .panel.svelte-1j3ylwg .progress:where(.svelte-1j3ylwg) {\n    flex: 1 1 100%;\n    height: 6px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: var(--line);\n  }\n  .panel.svelte-1j3ylwg .progress:where(.svelte-1j3ylwg) .bar:where(.svelte-1j3ylwg) {\n    height: 100%;\n    background: var(--accent);\n    transition: width 0.3s ease;\n  }\n  .primary.svelte-1j3ylwg {\n    background: var(--accent);\n    color: #fff;\n    font-weight: 600;\n    font-size: 0.9rem;\n    padding: 11px 20px;\n    border-radius: var(--radius-pill);\n    white-space: nowrap;\n  }\n  .primary.svelte-1j3ylwg:hover { background: var(--accent-dark); }\n  .primary.svelte-1j3ylwg:disabled { opacity: 0.6; cursor: default; }\n  code.svelte-1j3ylwg { background: var(--card-soft); padding: 2px 6px; border-radius: 6px; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function AdminRefresh($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, AdminRefresh);
	$.append_styles($$anchor, $$css);

	let stale = $.tag($.state(null // { stale, total, maxAgeDays, retentionDays, callsPerRestaurant, limit }
	), 'stale');
	let job = $.tag($.state(null // live status of whatever run the server is on
	), 'job');
	let starting = $.tag($.state(false), 'starting');
	let force = $.tag($.state(false // ignore the age threshold and take the whole linked catalogue
	), 'force');
	let unavailable = $.tag($.state(null), 'unavailable');
	let poll = null;
	const isAdmin = $.tag($.derived(() => $.strict_equals(session.user?.role, "admin")), 'isAdmin');
	const running = $.tag($.derived(() => $.strict_equals($.get(job)?.running, true)), 'running');
	const isOurRun = $.tag($.derived(() => $.get(running) && $.strict_equals($.get(job)?.kind, "data")), 'isOurRun');

	// What this press would actually touch: the stale set, or every linked listing under force —
	// and a forced pass is allowed to cover the whole catalogue in one go.
	const target = $.tag(
		$.derived(() => $.get(stale)
			? $.get(force) ? $.get(stale).total : $.get(stale).stale
			: 0),
		'target'
	);

	const batchSize = $.tag(
		$.derived(() => $.get(stale)
			? Math.min($.get(target), $.get(force) ? $.get(stale).forceLimit : $.get(stale).limit)
			: 0),
		'batchSize'
	);

	const progress = $.tag(
		$.derived(() => $.get(isOurRun) && $.get(job)?.progress?.total
			? Math.round($.get(job).progress.done / $.get(job).progress.total * 100)
			: 0),
		'progress'
	);

	async function loadPreview() {
		try {
			$.set(stale, (await $.track_reactivity_loss(api.staleData()))(), true);
			$.set(unavailable, null);
		} catch(error) {
			// A server without provider credentials still boots. This page has to say why it is empty
			// rather than render a button that cannot possibly work.
			$.set(unavailable, error.message ?? "Refresh is not configured on this server.", true);

			$.set(stale, null);
		}
	}

	async function start() {
		$.set(starting, true);

		try {
			$.set(job, (await $.track_reactivity_loss(api.refreshData($.get(stale)?.maxAgeDays, undefined, $.get(force))))(), true);
			pollStatus();
		} catch(error) {
			toastError(error.message ?? "Couldn't start the refresh.");
		} finally {
			$.set(starting, false);
		}
	}

	function pollStatus() {
		clearInterval(poll);

		poll = setInterval(
			async () => {
				try {
					const status = (await $.track_reactivity_loss(api.ingestStatus()))();

					$.set(job, status.status, true);

					if (!status.status.running) {
						clearInterval(poll);
						poll = null;

						const outcome = status.status.outcome;

						if (outcome) {
							toastSuccess(`Refreshed ${outcome.refreshed} listing(s), ${outcome.excerptsCached} excerpt(s), ` + `${outcome.photosCached} photo(s) — ${outcome.apiCalls} API call(s).`);
						}

						if (status.status.error) toastError(status.status.error);

						(await $.track_reactivity_loss(loadPreview()))();
					}
				} catch(error) {
					clearInterval(poll);
					poll = null;
					toastError(error.message ?? "Lost track of the refresh.");
				}
			},
			1500
		);
	}

	$.user_effect(() => {
		if (!$.get(isAdmin)) return;

		loadPreview();

		// A run started from another tab (or a reload mid-run) must still show up here: the server
		// owns the run, this page only polls it.
		api.ingestStatus().then((s) => {
			$.set(job, s.status, true);

			if (s.status.running) pollStatus();
		}).catch(() => {});

		return () => {
			clearInterval(poll);
			poll = null;
		};
	});

	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			{
				var consequent = ($$anchor) => {
					$.add_svelte_meta(
						() => EmptyState($$anchor, {
							icon: '🔒',
							title: 'Admins only',
							message: 'This area refreshes the provider data behind the listings.',
							action: { href: "/", label: "Back home" }
						}),
						'component',
						AdminRefresh,
						100,
						4,
						{ componentTag: 'EmptyState' }
					);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (session.loaded) $$render(consequent);
					}),
					'if',
					AdminRefresh,
					99,
					2
				);
			}

			$.append($$anchor, fragment_1);
		};

		var alternate_4 = ($$anchor) => {
			var fragment_3 = root_9();
			var node_2 = $.first_child(fragment_3);

			$.add_svelte_meta(() => AdminNav(node_2, { current: 'refresh' }), 'component', AdminRefresh, 108, 2, { componentTag: 'AdminNav' });

			var header = $.sibling(node_2, 2);
			var p = $.sibling($.child(header), 2);
			var text = $.child(p);

			$.reset(p);
			$.reset(header);

			var node_3 = $.sibling(header, 2);

			{
				var consequent_2 = ($$anchor) => {
					var div = root();
					var p_1 = $.child(div);
					var text_1 = $.child(p_1, true);

					$.reset(p_1);
					$.next(2);
					$.reset(div);
					$.template_effect(() => $.set_text(text_1, $.get(unavailable)));
					$.append($$anchor, div);
				};

				var consequent_3 = ($$anchor) => {
					var p_2 = root_1();

					$.append($$anchor, p_2);
				};

				var consequent_4 = ($$anchor) => {
					var div_1 = root_2();
					var div_2 = $.child(div_1);
					var div_3 = $.child(div_2);

					$.reset(div_2);

					var p_3 = $.sibling(div_2, 2);
					var text_2 = $.child(p_3);
					var span = $.sibling(text_2);
					var text_3 = $.child(span);

					$.reset(span);
					$.reset(p_3);
					$.reset(div_1);

					$.template_effect(() => {
						$.set_attribute(div_2, 'aria-valuenow', $.get(progress));
						$.set_style(div_3, `width: ${$.get(progress) ?? ''}%`);
						$.set_text(text_2, `${$.get(job).progress?.detail ?? "Starting…" ?? ''} `);

						$.set_text(text_3, `${$.get(job).progress?.done ?? 0 ?? ''}/${$.get(job).progress?.total ?? "?" ?? ''} ·
          ${$.get(job).progress?.apiCalls ?? 0 ?? ''} API calls`);
					});

					$.append($$anchor, div_1);
				};

				var alternate_3 = ($$anchor) => {
					var div_4 = root_8();
					var node_4 = $.child(div_4);

					{
						var consequent_5 = ($$anchor) => {
							var p_4 = root_3();
							var text_4 = $.child(p_4);

							$.reset(p_4);

							$.template_effect(() => $.set_text(text_4, `${$.strict_equals($.get(job).kind, "town") ? `An ingest of ${$.get(job).town}` : "A media refresh"} is running. Wait
          for it to finish — refreshing and ingesting share one slot so they cannot double-bill
          Google or race on the same listings.`));

							$.append($$anchor, p_4);
						};

						var alternate_2 = ($$anchor) => {
							var fragment_4 = root_7();
							var p_5 = $.first_child(fragment_4);
							var node_5 = $.child(p_5);

							{
								var consequent_6 = ($$anchor) => {
									var text_5 = $.text();

									$.template_effect(() => $.set_text(text_5, `Everything is current — nothing is cached more than ${$.get(stale).maxAgeDays ?? ''} days ago.`));
									$.append($$anchor, text_5);
								};

								var alternate = ($$anchor) => {
									var fragment_6 = root_4();
									var strong = $.first_child(fragment_6);
									var text_6 = $.child(strong, true);

									$.reset(strong);

									var text_7 = $.sibling(strong);

									$.template_effect(() => {
										$.set_text(text_6, $.get(stale).stale);

										$.set_text(text_7, ` listing${$.strict_equals($.get(stale).stale, 1) ? " has" : "s have"} provider
            data older than ${$.get(stale).maxAgeDays ?? ''} days.`);
									});

									$.append($$anchor, fragment_6);
								};

								$.add_svelte_meta(
									() => $.if(node_5, ($$render) => {
										if ($.strict_equals($.get(stale).stale, 0)) $$render(consequent_6); else $$render(alternate, -1);
									}),
									'if',
									AdminRefresh,
									152,
									10
								);
							}

							var span_1 = $.sibling(node_5, 2);
							var node_6 = $.child(span_1);

							{
								var consequent_7 = ($$anchor) => {
									var text_8 = $.text();

									$.template_effect(() => $.set_text(text_8, `Forced: this press covers ${$.get(batchSize) ?? ''} of ${$.get(stale).total ?? ''} linked listings — about
              ${$.get(batchSize) * $.get(stale).callsPerRestaurant} Google calls.`));

									$.append($$anchor, text_8);
								};

								var alternate_1 = ($$anchor) => {
									var text_9 = $.text();

									$.template_effect(() => $.set_text(text_9, `This press covers ${$.get(batchSize) ?? ''} of them — about ${$.get(batchSize) * $.get(stale).callsPerRestaurant}
              Google calls.`));

									$.append($$anchor, text_9);
								};

								$.add_svelte_meta(
									() => $.if(node_6, ($$render) => {
										if ($.get(force)) $$render(consequent_7); else $$render(alternate_1, -1);
									}),
									'if',
									AdminRefresh,
									159,
									12
								);
							}

							var node_7 = $.sibling(node_6, 2);

							{
								var consequent_8 = ($$anchor) => {
									var text_10 = $.text('Run it again for the rest.');

									$.append($$anchor, text_10);
								};

								$.add_svelte_meta(
									() => $.if(node_7, ($$render) => {
										if ($.get(target) > $.get(batchSize)) $$render(consequent_8);
									}),
									'if',
									AdminRefresh,
									166,
									12
								);
							}

							$.reset(span_1);
							$.reset(p_5);

							var node_8 = $.sibling(p_5, 2);

							{
								var consequent_9 = ($$anchor) => {
									var label = root_5();
									var input = $.child(label);

									$.remove_input_defaults(input);

									var span_2 = $.sibling(input, 2);
									var text_11 = $.child(span_2);

									$.next();
									$.reset(span_2);
									$.reset(label);
									$.template_effect(() => $.set_text(text_11, `Force: refresh all ${$.get(stale).total ?? ''} linked listings, whatever their age. `));

									$.bind_checked(
										input,
										function get() {
											return $.get(force);
										},
										function set($$value) {
											$.set(force, $$value);
										}
									);

									$.append($$anchor, label);
								};

								$.add_svelte_meta(
									() => $.if(node_8, ($$render) => {
										if ($.get(stale).total > 0) $$render(consequent_9);
									}),
									'if',
									AdminRefresh,
									170,
									8
								);
							}

							var node_9 = $.sibling(node_8, 2);

							{
								var consequent_10 = ($$anchor) => {
									var button = root_6();
									var text_12 = $.child(button, true);

									$.reset(button);

									$.template_effect(() => {
										button.disabled = $.get(starting);
										$.set_text(text_12, $.get(starting) ? "Starting…" : `Refresh ${$.get(batchSize)}`);
									});

									$.delegated('click', button, start);
									$.append($$anchor, button);
								};

								$.add_svelte_meta(
									() => $.if(node_9, ($$render) => {
										if ($.get(target) > 0) $$render(consequent_10);
									}),
									'if',
									AdminRefresh,
									183,
									8
								);
							}

							$.append($$anchor, fragment_4);
						};

						$.add_svelte_meta(
							() => $.if(node_4, ($$render) => {
								if ($.get(running)) $$render(consequent_5); else $$render(alternate_2, -1);
							}),
							'if',
							AdminRefresh,
							144,
							6
						);
					}

					$.reset(div_4);
					$.append($$anchor, div_4);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.get(unavailable)) $$render(consequent_2); else if (!$.get(stale)) $$render(consequent_3, 1); else if ($.get(isOurRun)) $$render(consequent_4, 2); else $$render(alternate_3, -1);
					}),
					'if',
					AdminRefresh,
					120,
					2
				);
			}

			$.template_effect(() => $.set_text(text, `Ratings, reviews and photos come from Google Places and are re-fetched by stored place ID.
      The site may keep them for only ${$.get(stale)?.retentionDays ?? 25 ?? ''} days, so a listing whose data
      is older than ${$.get(stale)?.maxAgeDays ?? 20 ?? ''} days is one failed weekly run away from an empty
      comparison block.`));

			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(isAdmin)) $$render(consequent_1); else $$render(alternate_4, -1);
			}),
			'if',
			AdminRefresh,
			98,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);